const btnConfirmCreateUser = {
  text: 'Crea una Cuenta'
};

export default btnConfirmCreateUser;
